var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcImportData = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "75px",
    viewBox: "0 0 70 75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1.-Import",
    transform: "translate(-115.000000, -314.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(35.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-import_csv",
    transform: "translate(50.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E1F5FE",
    points: "53.7476504 19.3843985 37.0065789 19.3843985 37.0065789 2.64332707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE2E5",
    points: "58 75 0 75 0 0 39.875 0 58 17.8571429"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "55 23 38 23 38 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "5 12 15 12 15 15 5 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "5 12 29 12 29 15 5 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "19 12 29 12 29 15 19 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "5 20 15 20 15 23 5 23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "19 20 29 20 29 23 19 23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "5 49 15 49 15 52 5 52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "19 49 43 49 43 52 19 52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "5 57 29 57 29 60 5 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#BEC4CA",
    points: "5 65 15 65 15 68 5 68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "19 57 29 57 29 60 19 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-2",
    fill: "#BEC4CA",
    points: "19 65 43 65 43 68 19 68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "33 49 43 49 43 52 33 52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "33 57 43 57 43 60 33 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-3",
    fill: "#BEC4CA",
    points: "33 65 43 65 43 68 33 68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "4.54747351e-13 30 58 30 58 44 4.54747351e-13 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,44 L70,61 L62,61 L62,75 L52,75 L52,61 L44,61 L57,44 Z",
    id: "Combined-Shape",
    fill: "#2565C7"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcImportData, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-import-data.398eb355.svg";
export { ForwardRef as ReactComponent };